<script>
import { mapState } from 'vuex';
import Loading from '../../components/loading.vue';

export default {
    name: "themeList",
    data() {
        return {
            info: {
                name: '',
                desc: ''
            },
            data: [],
            page: 1,
            allPage: 1,
            isLoading: false,
        };
    },
    computed: {
        ...mapState(['talentMenu', 'TMActiveIndex']),
    },
    components: {
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {
        TMActiveIndex: {
            handler: function (value) {
                if (this.talentMenu.length > 0) { 
                    this.info = this.talentMenu[value[0]].children[value[1]];
                }
            },
            immediate: true
        }
    },
    methods: {
        getData() {
            if (this.isLoading) { 
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('getTalentList', {
                category_id: this.$route.query.id,
                limit: 9,
                page: this.page,
                keywords: this.$route.query.s,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.data = this.data.concat(result.data.list);
                    this.allPage = result.data.last_page;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getData();
        }
    },
};
</script>

<template>
    <div class="theme_list layout_main">
        <p class="title">{{ info.name }}</p>
        <p class="desc">{{ info.desc }}</p>
        <div class="list flex flex_wrap">
            <router-link class="item" v-for="(item, index) in data" :key="index" :to="`images?id=${item.id}`">
                <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                <div class="name">{{ item.name }}</div>
            </router-link>
        </div>
        <Loading v-if="isLoading"/>
        <p class="no_more" v-else-if="data.length == 0">{{ $t('noMore') }}</p>
        <p class="no_more" v-else-if="page == allPage">{{ $t('itsOver') }}</p>
        <div class="flex justify_end" v-else>
            <div class="layout_btn_more" @click="getMore">{{ $t('find_out_more') }}</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.theme_list{
    padding-bottom: .7rem;
    @media only screen and (max-width: 750px) {
        padding-top: .3rem;
        .title,
        .desc{
            display: none;
        }
    }
    .title{
        font-size: .24rem;
        margin-bottom: .2rem;
    }
    .desc{
        font-size: .18rem;
        width: 7rem;
        margin-bottom: .3rem;
    }
    .list{
        gap: .45rem;
        padding-top: .2rem;
        .item{
            width: 3.7rem;
            cursor: pointer;
            // margin-top: -.2rem;
            .bg{
                height: 0;
                padding-bottom: 78.38%;
                margin-bottom: .1rem;
            }
            .name{
                text-align: center;
                font-size: .2rem;
            }
        }
        @media only screen and (max-width: 750px) {
            padding-top: 0;
            gap: .2rem .3rem;
            .item{
                width: 3.3rem;
                .bg{
                    padding-bottom: 100%;
                }
                .name{
                    font-size: .26rem;
                }
            }
        }
    }
}
</style>